import CircularProgress from '@mui/material/CircularProgress';

function MyCircularProgress({ color = 'black', thickness = 4, size = 30 }) {
  return (
    <CircularProgress sx={{ color: color }} thickness={thickness} size={size} />
  );
}

export default MyCircularProgress;
